export default __webpack_public_path__ + "7afcf0bb138694b03bba1a7c89532af6.svg";